import { Table, TableBody, TableRow, TableCell, Skeleton } from "@mui/material";

const TableRowsLoader = ({ rowsNum }: { rowsNum: number }) => {
  return (
    <Table role="presentation" aria-busy="true">
      <TableBody>
        {[...Array(rowsNum)].map((row, index) => (
          <TableRow key={index}>
            <TableCell component="th" scope="row">
              <Skeleton animation="wave" variant="text" width="250px" />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="text" width="250px" />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="text" width="250px" />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="text" width="250px" />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default TableRowsLoader;
